<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-position="left">
        <el-form-item label="开卡时间">
          <date-range-picker :value="payTime" @change="value => payTime = value" @getChange="dateChange"/>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input v-model="searchForm.merchantId" placeholder="请输入商户编号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="代理商编号">
          <el-input v-model="searchForm.agentId" placeholder="请输入代理商编号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="客户经理工号">
          <el-input v-model="searchForm.managerNo" placeholder="请输入客户经理工号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="客户经理姓名">
          <el-input v-model="searchForm.managerName" placeholder="请输入客户经理姓名" :clearable="true"/>
        </el-form-item>
        <el-form-item label="银行类型">
          <el-select v-model="searchForm.bankType" clearable>
            <el-option v-for="item in [{value: '', label: '全部类型'}, ...bankTypeList]" :key="item.value" :value="item.value" :label="item.label"/>
          </el-select>
        </el-form-item>
        <el-form-item label="报名状态">
          <el-select v-model="searchForm.enterState" clearable>
            <el-option label="全部状态" value=""></el-option>
            <el-option label="未报名" :value="0"></el-option>
            <el-option label="已报名" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
        <el-button type="default" :loading="exportLoading" @click="handleExport">导出</el-button>
      </el-form>
    </module-card>

    <module-card title="联拓商户管理">
      <batch-import
        opt="batch_apply"
        class="batchImport"
        button-text="批量报名商户"
        submit-name="batchAddApply"
        templateName="批量报名商户模板"
        fail-key="failMerchants"
        dialog-title="批量报名"
        @submit="importSubmit"
        :tableList="[
          { label: '商户编号', prop: 'mcode' },
          { label: '商户简称', prop: 'mname' },
          { label: '失败原因', prop: 'errorMsg' }
        ]"/>
      <el-table class="table" border :data="list" v-loading="tableLoading">
        <el-table-column
          label="开卡时间"
          prop="cardOpeningTime"
          width="160">
        </el-table-column>
        <el-table-column
          label="商户编号"
          prop="merchantId"
          width="120">
        </el-table-column>
        <el-table-column
          label="商户简称"
          prop="merchantName"
          width="140">
        </el-table-column>
        <el-table-column
          label="代理商编号"
          prop="agentId"
          width="120">
        </el-table-column>
        <el-table-column
          label="代理商名称"
          prop="agentName"
          width="120">
        </el-table-column>
        <el-table-column
          label="客户经理工号"
          prop="managerNo"
          width="120">
        </el-table-column>
        <el-table-column
          label="客户经理姓名"
          prop="managerName"
          width="120">
        </el-table-column>
        <el-table-column
          label="所属银行类型"
          prop="bankType"
          width="120">
          <template slot-scope="scope">
            <span>
              {{ getBankType(scope.row.bankType) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属银行名称"
          prop="bankName"
          width="120">
        </el-table-column>
        <el-table-column
          label="商户银行卡号"
          prop="merchantBankCard"
          width="170">
        </el-table-column>
        <el-table-column
          label="报名状态"
          prop="enterState"
          width="120">
          <template slot-scope="scope">
            <span>
              {{ scope.row.enterState === null || scope.row.enterState === 0 ? '未报名' : '已报名' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="最近操作人"
          prop="operator"
          width="120">
          <template slot-scope="scope">
            {{ scope.row.operator ? scope.row.operator : "-"}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作时间"
          prop="updateTime"
          width="160">
        </el-table-column>
        <el-table-column
          width="200"
          label="操作"
          fixed="right">
          <template slot-scope="scope">
            <div class="flex-space-around">
              <auth-button auth-type="span" opt="apply_activity" label="报名活动" class="editBtn"
                           @click.native="applyActivity(scope.row)"/>
              <auth-button auth-type="span" opt="view_apply_record" label="查看报名记录" class="editBtn"
                           @click.native="applyRecord(scope.row)"/>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="pageNo" :size="pageSize"
                  @changePage="value => { this.pageNo = value; getList() }"/>
    </module-card>
    <dialog-info
      :visible.sync="showManagerDialog"
      title="报名活动"
      @confirm="submitManager"
      @close="clearBankInfo"
      :comfirmLoading="addManagerLoading"
      size="middle"
      footerAlign="center">
      <el-form ref="managerForm" :model="managerForm" :rules="ruleData" label-width="100px" label-position="left">
        <el-form-item label="选择报名活动">
          <el-select v-model="managerForm.activityId" placeholder="请选择需报名的银行活动" @change="selectBankType">
            <el-option v-for="item in activityList" :key="item.activityId" :value="item.activityId"
                       :label="item.activityName"/>
          </el-select>
        </el-form-item>
        <el-form-item prop="extendedSource" label="拓展来源">
          <el-radio-group v-model.trim="managerForm.extendedSource">
            <el-radio :label="10">银行推荐</el-radio>
            <el-radio :label="0">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="settleType" label="补贴对象">
          <el-radio-group v-model.trim="managerForm.settleType">
            <el-radio :label="0" v-show="settleShow1">补贴给商户</el-radio>
            <el-radio :label="10" v-show="settleTypeShow && settleShow2">补贴给代理商</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="managerForm.remark" placeholder="请输入备注信息" class="form-input"/>
        </el-form-item>
      </el-form>
    </dialog-info>
    <!-- 查看报名记录 -->
    <dialog-info
      :visible.sync="showManagerDetailDialog"
      title="查看报名记录"
      size="large"
      footerAlign="center"
      @confirm="showManagerDetailDialog = false, managerDetailList = [], id = '', applyPageNo = 1"
      @close="showManagerDetailDialog = false, managerDetailList = [], id = '', applyPageNo = 1"
    >
      <el-table class="table" border :data="managerDetailList" v-loading="managerDetailLoading">
        <el-table-column
          label="活动编号"
          width="170"
          prop="activityId">
        </el-table-column>
        <el-table-column
          label="活动名称"
          prop="activityName">
        </el-table-column>
        <el-table-column
          label="操作人"
          prop="operator">
        </el-table-column>
        <el-table-column
          label="报名时间"
          prop="createTimeStr">
        </el-table-column>
        <el-table-column
          label="报名状态"
          prop="enterState">
          <template slot-scope="scope">
            <span>
              {{ scope.row.enterState === null || scope.row.enterState === 0 ? '报名失败' : '报名成功' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="失败原因"
          prop="failReason">
        </el-table-column>
      </el-table>
      <pagination :count="applyTotal" :page-no="applyPageNo" :size="applyPageSize"
            @changePage="value => { this.applyPageNo = value; applyRecord() }"/>
    </dialog-info>
  </div>
</template>
<script>
import dialogInfo from '@/components/layout/dialogInfo'
import pagination from '@/components/pagination'
import dateRangePicker from '@/components/dateRangePicker'
import batchImport from '@/components/upload/batchImport'
import { downJumpConfirm, formateDate } from '@/assets/js/utils'

export default {
  name: 'uniteMerchantManage',
  components: {
    dialogInfo,
    pagination,
    dateRangePicker,
    batchImport
  },
  data () {
    return {
      id: '',
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      applyTotal: 0,
      applyPageNo: 1,
      applyPageSize: 10,
      tableLoading: false,
      addManagerLoading: false,
      showManagerDialog: false,
      showManagerDetailDialog: false,
      managerForm: {
        merchantIds: '',
        activityId: '',
        extendedSource: '',
        settleType: '',
        remark: ''
      },
      ruleData: {
        extendedSource: [{
          required: true,
          message: '请选择拓展来源',
          trigger: 'change'
        }],
        settleType: [{
          required: true,
          message: '请选择补贴对象',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入客户经理姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入客户经理手机',
          trigger: 'blur'
        }]
      },
      bankTypeList: [
        { value: '1', label: '总行' },
        { value: '2', label: '分行' },
        { value: '3', label: '支行' }
      ],
      activityList: [],
      bankList: [],
      bankTypeListHashMap: {
        1: '总行',
        2: '分行',
        3: '支行'
      },
      searchForm: {
        cardOpeningStart: '',
        cardOpeningEnd: '',
        merchantId: '',
        agentId: '',
        managerNo: '',
        managerName: '',
        bankType: '',
        enterState: '',
        bankCode: ''
      },
      exportLoading: false,
      searchLoading: false,
      addTime: [],
      managerDetailList: [],
      managerDetailLoading: false,
      settleTypeShow: true, // 月返显示true
      settleShow1: true, // 补贴给代理商
      settleShow2: true // 补贴给商户
    }
  },
  mounted () {
    const endTime = formateDate(new Date()).substring(0, 10) + ' 23:59:59'
    const startTime = formateDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)).substring(0, 10) + ' 00:00:00'
    this.payTime = [startTime, endTime]
    this.init()
  },
  computed: {},
  methods: {
    async init () {
      this.getList()
    },
    formatBankType (row) {
      const { bankType } = row
      return this.bankTypeListHashMap[bankType] || '未知类型'
    },
    // 获取活动类型是月返还是实返
    selectBankType (val) {
      var obj = {}
      obj = this.activityList.find(item => {
        return item.activityId === val
      })
      // 月返
      this.settleShow1 = true
      this.settleShow2 = true
      if (obj.activityType === 10) {
        this.settleTypeShow = true
        switch (obj.settleType) {
          case '0':
            this.settleShow2 = false
            this.managerForm.settleType = 0
            break
          case '10':
            this.settleShow1 = false
            this.managerForm.settleType = 10
            break
          case '':
            this.managerForm.settleType = ''
            break
          default:
            this.managerForm.settleType = 0
        }
      } else {
        // 实返
        this.settleTypeShow = false
        obj.settleType === '0' ? this.managerForm.settleType = 0 : this.managerForm.settleType = ''
      }
    },
    dateChange (value) {
      this.payTime = value
    },
    getList () {
      if (!this.payTime || !this.payTime[0] || !this.payTime[1]) {
        this.$message({
          type: 'error',
          message: '请选择时间进行查询',
          showClose: true
        })
        return
      }
      this.searchForm.cardOpeningStart = this.payTime && this.payTime[0] ? this.payTime[0] : ''
      this.searchForm.cardOpeningEnd = this.payTime && this.payTime[1] ? this.payTime[1] : ''
      this.tableLoading = true
      this.searchLoading = true
      const params = Object.assign({}, this.searchForm, {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
      this.$axios.post(this.$api.coupletMerchantList, params).then(res => {
        if (res.respCode === '0') {
          this.list = res.data.list
          this.total = res.data.count
        }
        this.tableLoading = false
        this.searchLoading = false
      })
    },
    applyActivity (row) {
      this.$axios.get(this.$api.applyActivityList, { params: { managerId: row.managerId } }).then(res => {
        if (res.respCode === '0') {
          this.activityList = res.data.list
        }
      })
      this.showManagerDialog = true
      this.managerForm.merchantIds = row.merchantId
    },
    applyRecord (row) {
      if (row) {
        this.id = row.id
      }
      this.showManagerDetailDialog = true
      this.managerDetailLoading = true
      const params = Object.assign({}, { id: this.id }, {
        pageSize: this.applyPageSize,
        pageNo: this.applyPageNo
      })
      this.$axios.post(this.$api.applyRecord, params).then(res => {
        this.managerDetailLoading = false
        if (res.respCode === '0') {
          this.managerDetailList = res.data.list
          this.applyTotal = res.data.count
        }
      })
      /* Object.keys(row).forEach(key => {
        row[key] && (this.managerForm[key] = row[key])
      })
      this.$nextTick(() => {
        this.showManagerDialog = true
      }) */
    },
    handleExport () {
      this.exportLoading = true
      this.$axios.post(this.$api.exportCoupletMerchant, this.searchForm).then((res) => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    submitManager () {
      let managerValid = true
      this.$refs.managerForm.validate((valid) => {
        if (!valid) {
          managerValid = false
        }
      })
      if (!managerValid) {
        this.$message({
          type: 'warning',
          message: '请完善信息后提交！'
        })
      } else {
        this.addManagerLoading = true
        this.$axios.post(this.$api.applyActivity, this.managerForm).then(res => {
          if (res.respCode === '0') {
            this.addManagerLoading = false
            this.showManagerDialog = false
            this.$message({
              type: 'success',
              message: '报名' + res.respMsg
            })
            this.getList()
          }
        })
      }
    },
    clearBankInfo () {
      this.settleShow1 = true
      this.settleShow2 = true
      this.settleTypeShow = true
      this.showManagerDialog = false
      this.managerForm = this.$options.data().managerForm
      this.$nextTick(() => {
        this.$refs.managerForm.clearValidate()
        // this.$refs.form0[0].clearValidate()
      })
    },
    search () {
      this.pageNo = 1
      this.getList()
    },
    importSubmit (result) {
      if (result) {
        this.getList()
      }
    },
    getBankType (type) {
      const result = this.bankTypeList.filter(item => {
        return item.value === type
      })
      if (result.length === 1) {
        return result[0].label
      } else {
        return '未知'
      }
    }
  }
}
</script>
<style scoped>
  .table {
    margin-top: 20px;
  }

  .form-flex-item {
    margin-right: 5px;
  }

  .icon {
    width: 14px;
    height: 14px;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    border-radius: 50%;
    display: inline-block;
    background: #409EFF;
    color: #fff;
    margin-left: 12px;
    cursor: pointer;
    user-select: none; /* Standard syntax */
  }

  .form-input {
    width: 550px;
  }

  .inner-input {
    width: 240px;
  }
</style>
